import React from 'react'
import PropTypes from 'prop-types'

import { Box, Container, Grid, Typography } from '@material-ui/core'
import { useStoreState } from 'easy-peasy'

import Image from 'artkive/components/Image'
import OtherProductsSection from 'artkive/components/sections/OtherProductsSection'
import { PRODUCT_SLIDES } from 'artkive/components/sections/ProductsCarousel/ProductsCarousel.constants'
import Social from 'artkive/components/Social'
import Swipe from 'artkive/components/Swipe'
import { AMOUNT_OF_ART } from 'artkive/utils/giftCard'
import routes from 'artkive/utils/routes'
import theme from 'artkive/utils/theme'

import HowItWorks from 'images/ecom/giftcards/GC-HowItWorks-1.svg'
import HowItWorks2 from 'images/ecom/giftcards/GC-HowItWorks-2.svg'
import HowItWorks3 from 'images/ecom/giftcards/GC-HowItWorks-3.svg'

import { EGiftCardConfirmation, PhysicalGiftCardConfirmation } from './GiftCardConfirmationVariants'

const giftCardVariants = {
  physical: PhysicalGiftCardConfirmation,
  egift: EGiftCardConfirmation,
}

const GiftCardConfirmation = ({ params }) => {
  const { confirmation } = useStoreState(({ giftCardStore }) => giftCardStore)

  const ConfirmationDetails = giftCardVariants[params.uuid] ?? giftCardVariants.physical

  return (
    <Box minHeight='100vh'>
      <ConfirmationDetails params={confirmation} />

      <Box py={10} textAlign='center' bgcolor={theme.colors.white.dark}>
        <Container>
          <Box mb={10}>
            <Typography gutterBottom variant='h4'>
              How It Works
            </Typography>
          </Box>

          <Grid container spacing={2}>
            <Grid xs={12} md={4} item>
              <Box textAlign='center'>
                <Box mb={2}>
                  <Image src={HowItWorks} style={{ maxWidth: '100px' }} />
                </Box>
                <Box mb={2}>
                  <Typography gutterBottom variant='h6'>
                    Redeem Gift Card Online
                  </Typography>
                </Box>
                <Typography>Your gift card recipient can redeem their gift card during checkout.</Typography>
              </Box>
            </Grid>
            <Grid xs={12} md={4} item>
              <Box textAlign='center'>
                <Box mb={2}>
                  <Image src={HowItWorks2} style={{ maxWidth: '100px' }} />
                </Box>
                <Box mb={2}>
                  <Typography gutterBottom variant='h6'>
                    Send Us {AMOUNT_OF_ART} Art Pieces
                  </Typography>
                </Box>
                <Typography>
                  Using the Artkive box, your gift card recipient will send us {AMOUNT_OF_ART} art pieces.
                </Typography>
              </Box>
            </Grid>
            <Grid xs={12} md={4} item>
              <Box textAlign='center'>
                <Box mb={2}>
                  <Image src={HowItWorks3} style={{ maxWidth: '100px' }} />
                </Box>
                <Box mb={2}>
                  <Typography gutterBottom variant='h6'>
                    Receive Book
                  </Typography>
                </Box>
                <Typography>
                  After your gift card recipient has approved a digital proof of their book, we&apos;ll print &amp; ship
                  it to them.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box mt={6}>
                <Swipe href={routes.faqs} target='_blank' underline='none' variant='h6'>
                  View FAQs
                </Swipe>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box py={8} bgcolor={theme.colors.white.dark}>
        {PRODUCT_SLIDES.map((slide, index) => (
          <OtherProductsSection key={slide.href} {...slide} mirrored={index % 2 === 1} colorIndex={index} />
        ))}
      </Box>
      <Social />
    </Box>
  )
}

GiftCardConfirmation.propTypes = {
  params: PropTypes.object,
}

export default GiftCardConfirmation
